import React from 'react';
import { useLocalize } from 'localize-react';
import { JourneyStatusType } from '@transferz/fe-models';
import Typography from '@transferz/fe-component-library/src/components/typography/Typography';
import BottomDrawer from '@transferz/fe-component-library/src/components/bottomDrawer/BottomDrawer';
import { Button } from '@transferz/fe-component-library/src/components/button/Button';
import PhoneRing from '@transferz/fe-component-library/src/components/icons/PhoneRingIcon';
import './more-info.scss';

interface IMoreInfoPopupProps {
  isPopupOpen: boolean;
  setIsPopupOpen: Function;
  journey: any
}

export const MoreInfoPopup: React.FC<IMoreInfoPopupProps> = ({
  isPopupOpen,
  setIsPopupOpen,
  journey,
}) => {
  const { translate } = useLocalize();
  const status = journey?.status || '';
  const canContactDriver = status === JourneyStatusType.DriverArrived || status === JourneyStatusType.DriverUnderway || status === JourneyStatusType.JourneyInProgress;
  const allowedToModifyJourney = journey?.travellerInfo?.allowedToModifyJourney;

  return (
    <div className={`more-info-popup ${canContactDriver ? 'more-info-popup-large' : ''}`}>
      <BottomDrawer
        title={translate('journey_changeBooking')}
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
        enableDesktopView={true}
      >
        <div>
          {allowedToModifyJourney
            ? (
              <>
                <div className="mb-24">
                  <Typography variant="body1">{translate('journey_transcoShouldBeContacted')}</Typography>
                </div>
                <div className="mb-12">
                  <Typography variant="subtitle1">{translate('journey_stillNeedTheChange')}</Typography>
                </div>
              </>
            )
            : (
              <div className="mb-24">
                <Typography variant="body1">{translate('journey_bookerShouldBeContacted')}</Typography>
              </div>
            )
          }
          {canContactDriver && allowedToModifyJourney && (
            <>
              <div className="mb-12">
                <a href={`tel:${journey?.driver?.mobilePhoneNumber}`} className="call-link">
                  <Button
                    priority="primary"
                    variant="info"
                    label={translate('callDriver')}
                    icon={<PhoneRing />}
                    iconPosition="left"
                    size="lg"
                  />
                </a>
              </div>
              <div className="mb-24 mt-24">
                <Typography variant="body1">{translate('journey_transcoDirectContact')}</Typography>
              </div>
            </>
          )}
          {allowedToModifyJourney && (
            <a href={`tel:${journey?.transferCompany?.phone}`} className="call-link">
              <Button
                priority="primary"
                variant="info"
                label={translate('journey_callTransco')}
                icon={<PhoneRing />}
                iconPosition="left"
                size="lg"
              />
            </a>
          )}
          <div className="cancelBookingFooter d-flex justify-content-flex-end">
            <Button
              className="mr-16 closeWindow"
              label={translate('booking_closeWindow')}
              priority="secondary"
              onClick={() => setIsPopupOpen(false)}
            />
          </div>
        </div>
      </BottomDrawer>
    </div>
  );
};
